import React from "react";

export function PageSpecificSignIn() {
  return <h1>SPECIFIC_SIGN_IN</h1>;
}
